module.exports = __webpack_public_path__ + "static/media/openness-mismatch-fr.60a50e7d.png";